export const BONDS_FAQS = [
  {
    id: 0,
    question: 'What are bonds?',
    answer:
      'Bonds are fixed-income instruments that represent a loan made by an investor to a borrower, typically a corporation or government. In return, the issuer agrees to pay you interest (called the coupon) at regular intervals and repay the principal amount on a fixed maturity date.',
  },
  {
    id: 1,
    question: 'How do listed bonds work?',
    answer:
      'Listed bonds are bonds that are traded on a recognised stock exchange such as the NSE or BSE. When you invest, you lend money to the issuer and earn a pre-defined coupon over the tenure. Since they are listed, they offer greater transparency and the option to sell on the exchange before maturity, subject to market liquidity.',
  },
  {
    id: 2,
    question: 'What is a coupon rate?',
    answer:
      'The coupon rate is the annual interest paid by the bond issuer, expressed as a percentage of the face value of the bond. For example, a bond with a face value of ₹1,000 and an 8% coupon rate pays ₹80 in interest each year, distributed as per the payout frequency (monthly, quarterly, half-yearly, or annually).',
  },
  {
    id: 3,
    question: 'What is Yield to Maturity (YTM)?',
    answer:
      'Yield to Maturity (YTM) is the total expected return on a bond if it is held until maturity, accounting for the purchase price, coupon payments, and the face value repaid at maturity. It is the most accurate measure to compare returns across different bonds.',
  },
  {
    id: 4,
    question: 'What are bond ratings and why do they matter?',
    answer:
      'Bond ratings are assessments by credit rating agencies such as CRISIL, ICRA, or CARE that indicate the issuer’s ability to repay its debt. Higher-rated bonds (e.g., AAA) carry lower credit risk but typically offer lower yields, while lower-rated bonds offer higher yields to compensate for higher risk. Ratings help you gauge the safety of your investment.',
  },
  {
    id: 5,
    question: 'Can I sell my bonds before maturity?',
    answer:
      'Yes. Since these are listed bonds, you can sell them on the exchange before maturity, subject to market liquidity and prevailing market prices. Do note that the sale price may be higher or lower than your purchase price depending on interest rate movements and demand at the time of sale.',
  },
  {
    id: 6,
    question: 'What is the minimum amount required to invest in bonds?',
    answer:
      'The minimum investment depends on the face value of the bond and the issuer’s terms. Many listed bonds are available for as low as the price of a single unit, making them accessible to retail investors. The exact minimum is shown on each deal’s details page.',
  },
  {
    id: 7,
    question: 'How can I earn commission on these deals?',
    answer:
      'Commissions are calculated based on the investment amount and typically range from 30% to 50% of the revenue generated from a deal (excl. gst). Since each deal has a different revenue structure, a fixed commission percentage cannot be defined.',
  },
  {
    id: 8,
    question: 'How can I facilitate a client’s investment in a bond?',
    answer:
      'Select the relevant deal, choose the client you would like to invest, and click “I’m Interested.” A Relationship Manager (RM) will then contact you to guide you through the investment process and complete the necessary formalities.',
  },
];

export const formatAmountWithText = (amount: number): string => {
  if (amount === null || amount === undefined) return '';

  const absAmount = Math.abs(amount);

  if (absAmount >= 1_00_00_000) {
    // Crores
    return `${(amount / 1_00_00_000).toFixed(2).replace(/\.00$/, '')} Cr`;
  }

  if (absAmount >= 1_00_000) {
    // Lakhs
    return `${(amount / 1_00_000).toFixed(2).replace(/\.00$/, '')} Lakh`;
  }

  if (absAmount >= 1_000) {
    // Thousands
    return `${(amount / 1_000).toFixed(2).replace(/\.00$/, '')}K`;
  }

  return amount.toString();
};
